export default "__VITE_ASSET__43f79560__"